import React from 'react';
import { Container, Title } from './styles';

interface ConfiguracoesPacientesProps {
  camposSelecionados: string[];
  setCamposSelecionados: React.Dispatch<React.SetStateAction<string[]>>;
}

export const ConfiguracoesPacientes: React.FC<ConfiguracoesPacientesProps> = ({
  camposSelecionados,
  setCamposSelecionados,
}) => {
  const aoSelecionarCampo = (campo: string) => {
    if (camposSelecionados.includes(campo)) {
      setCamposSelecionados(camposSelecionados.filter(c => c !== campo));
      return;
    }

    setCamposSelecionados([...camposSelecionados, campo]);
  };

  const estaSelecionado = (campo: string) => {
    return camposSelecionados.includes(campo);
  };

  return (
    <>
      <Title>Selecione os campos para o relatório</Title>

      <Container>
        <label>
          <input
            type="checkbox"
            checked={estaSelecionado('Nome')}
            onChange={() => {
              aoSelecionarCampo('Nome');
            }}
          />
          Nome
        </label>

        <label>
          <input
            type="checkbox"
            checked={estaSelecionado('CPF')}
            onChange={() => {
              aoSelecionarCampo('CPF');
            }}
          />
          CPF
        </label>

        <label>
          <input
            type="checkbox"
            checked={estaSelecionado('Data Nascimento')}
            onChange={() => {
              aoSelecionarCampo('Data Nascimento');
            }}
          />
          Data Nascimento
        </label>

        <label>
          <input
            type="checkbox"
            checked={estaSelecionado('Convenio')}
            onChange={() => {
              aoSelecionarCampo('Convenio');
            }}
          />
          Convenio
        </label>

        <label>
          <input
            type="checkbox"
            checked={estaSelecionado('Cidade')}
            onChange={() => {
              aoSelecionarCampo('Cidade');
            }}
          />
          Cidade
        </label>

        <label>
          <input
            type="checkbox"
            checked={estaSelecionado('CEP')}
            onChange={() => {
              aoSelecionarCampo('CEP');
            }}
          />
          CEP
        </label>

        <label>
          <input
            type="checkbox"
            checked={estaSelecionado('Endereço')}
            onChange={() => {
              aoSelecionarCampo('Endereço');
            }}
          />
          Endereço
        </label>

        <label>
          <input
            type="checkbox"
            checked={estaSelecionado('Número')}
            onChange={() => {
              aoSelecionarCampo('Número');
            }}
          />
          Número
        </label>

        <label>
          <input
            type="checkbox"
            checked={estaSelecionado('Complemento')}
            onChange={() => {
              aoSelecionarCampo('Complemento');
            }}
          />
          Complemento
        </label>

        <label>
          <input
            type="checkbox"
            checked={estaSelecionado('Bairro')}
            onChange={() => {
              aoSelecionarCampo('Bairro');
            }}
          />
          Bairro
        </label>

        <label>
          <input
            type="checkbox"
            checked={estaSelecionado('Estado')}
            onChange={() => {
              aoSelecionarCampo('Estado');
            }}
          />
          Estado
        </label>

        <label>
          <input
            type="checkbox"
            checked={estaSelecionado('País')}
            onChange={() => {
              aoSelecionarCampo('País');
            }}
          />
          País
        </label>

        <label>
          <input
            type="checkbox"
            checked={estaSelecionado('Nome Pai')}
            onChange={() => {
              aoSelecionarCampo('Nome Pai');
            }}
          />
          Nome Pai
        </label>

        <label>
          <input
            type="checkbox"
            checked={estaSelecionado('Nome Mãe')}
            onChange={() => {
              aoSelecionarCampo('Nome Mãe');
            }}
          />
          Nome Mãe
        </label>

        <label>
          <input
            type="checkbox"
            checked={estaSelecionado('Responsável')}
            onChange={() => {
              aoSelecionarCampo('Responsável');
            }}
          />
          Responsável
        </label>

        <label>
          <input
            type="checkbox"
            checked={estaSelecionado('CPF Responsável')}
            onChange={() => {
              aoSelecionarCampo('CPF Responsável');
            }}
          />
          CPF Responsável
        </label>

        <label>
          <input
            type="checkbox"
            checked={estaSelecionado('RG Responsável')}
            onChange={() => {
              aoSelecionarCampo('RG Responsável');
            }}
          />
          RG Responsável
        </label>

        <label>
          <input
            type="checkbox"
            checked={estaSelecionado('Estado Civil Responsável')}
            onChange={() => {
              aoSelecionarCampo('Estado Civil Responsável');
            }}
          />
          Estado Civil Responsável
        </label>

        <label>
          <input
            type="checkbox"
            checked={estaSelecionado('Credencial')}
            onChange={() => {
              aoSelecionarCampo('Credencial');
            }}
          />
          Credencial
        </label>

        <label>
          <input
            type="checkbox"
            checked={estaSelecionado('Validade Credencial')}
            onChange={() => {
              aoSelecionarCampo('Validade Credencial');
            }}
          />
          Validade Credencial
        </label>

        <label>
          <input
            type="checkbox"
            checked={estaSelecionado('Observações')}
            onChange={() => {
              aoSelecionarCampo('Observações');
            }}
          />
          Observações
        </label>

        <label>
          <input
            type="checkbox"
            checked={estaSelecionado('Contatos')}
            onChange={() => {
              aoSelecionarCampo('Contatos');
            }}
          />
          Contatos
        </label>

        <label>
          <input
            type="checkbox"
            checked={estaSelecionado('Ultimo Local')}
            onChange={() => {
              aoSelecionarCampo('Ultimo Local');
            }}
          />
          Último Local
        </label>
      </Container>
    </>
  );
};
